import React from 'react';
import { useIsMobile } from '../hooks/useDeviceType';

// Desktop Components (ALL in pages folder)
import ClientManagement from './pages/ClientManagement';
import InvoiceOversight from './pages/InvoiceOversight';
import StaffManagement from './pages/StaffManagement';
import SecurityLogs from './pages/SecurityLogs';
import StaffSettings from './pages/StaffSettings';

// Mobile Components (ALL in staff folder)
import MobileClientManagement from './staff/MobileClientManagement';
import MobileInvoiceOversight from './staff/MobileInvoiceOversight';
import MobileStaffManagement from './staff/MobileStaffManagement';
import MobileSecurityLogs from './staff/MobileSecurityLogs';
import MobileStaffSettings from './staff/MobileStaffSettings';

/**
 * Responsive Client Management - renders appropriate component based on device type
 */
export const ResponsiveClientManagement = (props) => {
  const isMobile = useIsMobile();
  
  if (isMobile) {
    return <MobileClientManagement {...props} />;
  }
  
  return <ClientManagement {...props} />;
};

/**
 * Responsive Invoice Oversight - renders appropriate component based on device type
 */
export const ResponsiveInvoiceOversight = (props) => {
  const isMobile = useIsMobile();
  
  if (isMobile) {
    return <MobileInvoiceOversight {...props} />;
  }
  
  return <InvoiceOversight {...props} />;
};

/**
 * Responsive Staff Management - renders appropriate component based on device type
 */
export const ResponsiveStaffManagement = (props) => {
  const isMobile = useIsMobile();
  
  if (isMobile) {
    return <MobileStaffManagement {...props} />;
  }
  
  return <StaffManagement {...props} />;
};

/**
 * Responsive Security Logs - renders appropriate component based on device type
 */
export const ResponsiveSecurityLogs = (props) => {
  const isMobile = useIsMobile();
  
  if (isMobile) {
    return <MobileSecurityLogs {...props} />;
  }
  
  return <SecurityLogs {...props} />;
};

/**
 * Responsive Staff Settings - renders appropriate component based on device type
 */
export const ResponsiveStaffSettings = (props) => {
  const isMobile = useIsMobile();
  
  if (isMobile) {
    return <MobileStaffSettings {...props} />;
  }
  
  return <StaffSettings {...props} />;
};

export default {
  ResponsiveClientManagement,
  ResponsiveInvoiceOversight,
  ResponsiveStaffManagement,
  ResponsiveSecurityLogs,
  ResponsiveStaffSettings
};

